import { UPDATE_SEARCHTDATA_DUNOCHOVAY } from "../../actions/DuNoChoVay/actionTypes";

const initialState = {
  dateFrom: "01/01/2001",
  dateTo: "01/01/4000",
  kieuVay: 0,
  tinhTrang: -1,
};

const updateDataSearch = (state, action) => ({
  ...action.payload,

  //matentaisan: action.payload.matentaisan,
  //searchText: action.payload,
});

export const dataSearchDuNoChoVay = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_DUNOCHOVAY:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchDuNoChoVay;
